<template>
  <el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading || loadingDelete">
    <el-row class="clients-panel cash-list">
      <el-col :span="20" :offset="2" class="clients-panel-container">
        <el-row class="black-inputs">
          <div class="cash-header">
            <h2>Ouverture et fermeture des salles</h2>
            <div class="nav-toggle" @click="showHidePopupCreateRoom">
              <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
            </div>
          </div>
          <br>
          <el-row class="dateChooser">
            <el-col :md="{ span: 24 }" :sm="{ span: 24 }" :xs="24">
              <el-date-picker class="datePicker" ref="picker" v-model="datesLocked"
                :picker-options="{ firstDayOfWeek: 1 }" type="daterange" range-separator="au"
                start-placeholder="Date de début" end-placeholder="Date de fin" format="dd/MM/yyyy" />
            </el-col>
            <el-col :sm="{ span: 8 }" :xs="24">
              <el-select v-model="serviceState" placeholder="Ouvrir / Fermer">
                <el-option key="0" label="Ouvrir" value="ouvrir">
                </el-option>
                <el-option key="1" label="Fermer" value="fermer">
                </el-option>
              </el-select>
            </el-col>
            <el-col :sm="{ span: 7, offset: 1 }" :xs="24">
              <el-select v-model="roomLocked" multiple placeholder="Salle">
                <el-option v-for="t in getRooms" :key="t.id" :label="t.name" :value="t.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :sm="{ span: 7, offset: 1 }" :xs="24">
              <el-select v-model="serviceLocked" multiple placeholder="Service">
                <el-option v-for="t in getServices" :key="t" :label="t" :value="t">
                </el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="{ span: 24 }">
              <el-popover v-if="getEntrysIsValid" placement="top" width="200" v-model="popupValid"
                popper-class="popup-delete black-inputs">
                <p>
                  Êtes vous sûr de vouloir<br>
                  {{ serviceState }} {{ getSelectRoomNames }} <br>
                  pour {{ getSelectServicesNames }} <br>
                  du {{ dateRenderer(this.datesLocked[0]) }} - {{ dateRenderer(this.datesLocked[1]) }}
                </p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" class="dark" type="primary" @click="popupValid = false">Annuler</el-button>
                  <el-button type="primary" size="mini" @click="createNewLockedRoomEntry()">Confirmer</el-button>
                </div>
                <el-button class="primary" slot="reference">Valider</el-button>
              </el-popover>
              <el-button type="primary" :disabled="true" v-if="!getEntrysIsValid">Valider</el-button>
            </el-col>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import { Notification } from 'element-ui';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { arrayOfTimestamp } from '../../tools/timeTool';

export default {
  name: 'LockedRoomsList',
  components: {},
  data() {
    return {
      datesLocked: {},
      serviceLocked: [],
      roomLocked: [],
      serviceState: '',
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      loadingDelete: false,
      popupValid: false
    }
  },
  computed: {
    ...mapGetters({
      getAllServicesIdsAndName: 'newServices/getAllServicesIdsAndName',
      getLockedRooms: 'newRooms/getLockedRooms',
      getRoomsDatas: 'newRooms/getRoomsDatas',
      getLabelMonth: 'calendar/getLabelMonth'
    }),
    getServices: function () {
      let tabServices = this.getAllServicesIdsAndName.slice()
      tabServices.unshift('Tous les services')
      return tabServices
    },
    getRooms: function () {
      if (this.getRoomsDatas) {
        let tabRooms = Object.values(this.getRoomsDatas).slice()
        tabRooms.unshift({
          id: 'toutes-les-salles',
          name: 'Toutes les salles'
        })
        return tabRooms
      }
      return []
    },
    getEntrysIsValid: function () {
      if (this.datesLocked.length > 1 &&
        this.serviceLocked.length > 0 && this.serviceState !== '' && this.roomLocked.length > 0) {
        return true
      }

      return false
    },
    getSelectRoomNames: function () {
      let allRooms = this.roomLocked.find(el => { return el === 'toutes-les-salles' })
      if (allRooms) return 'Toutes les salles'
      else {
        if (this.roomLocked.length > 1) {
          let string = 'les salles: '
          this.roomLocked.forEach(el => {
            string += `${this.getRoomsDatas[el].name}, `
          })
          return string
        } else {
          return `la salle ${this.getRoomsDatas[this.roomLocked[0]].name}`
        }
      }
    },
    getSelectServicesNames: function () {
      let allServices = this.serviceLocked.find(el => el === 'Tous les services')
      if (allServices) return 'Tous les services'
      else {
        if (this.serviceLocked.length > 1) {
          let string = 'les services du: '
          this.serviceLocked.forEach(el => {
            string += `${el}, `
          })
          return string
        } else {
          return `le service du ${this.serviceLocked[0]}`
        }
      }
    }
  },
  created: function () { },
  methods: {
    ...mapActions({
      createLockedRooms: 'newRooms/createLockedRooms',
      deleteLockedRooms: 'newRooms/deleteLockedRooms',
      showHidePopupCreateRoom: 'displayer/showHidePopupCreateRoom',
      showHideLockedRoom: 'displayer/showHideLockedRoom'
    }),
    ...mapMutations({
      setDialogError: 'displayer/setDialogError',
      setDialogEditCash: 'displayer/setDialogEditCash',
      setCashEditEntry: 'cash/setCashEditEntry'
    }),
    current_change: function (currentPage) {
      this.currentPage = currentPage
    },
    strUcFirst: function (a) {
      return (`${a}`).charAt(0).toUpperCase() + a.substr(1)
    },
    dateRenderer: function (date) {
      return `${date.getDate()} ${this.getLabelMonth(date.getMonth())} ${date.getFullYear()}`
    },
    successClose: function () {
      Notification.success({
        title: 'Donnée mise à jour pour la fermeture des services',
        message: '',
        position: 'bottom-right'
      })
      this.loading = false
      this.datesLocked = {}
      this.serviceLocked = []
      this.serviceState = ''
      this.roomLocked = []
    },
    createLockRooms: function (days, service, room) {
      this.createLockedRooms({
        days: days,
        service: service,
        room: room
      }).then(() => {
        this.successClose()
      }).catch((err) => {
        console.error(err)
        this.successClose()
      })
    },
    deleteLockRooms: function (days, service, room) {
      this.deleteLockedRooms({
        days: days,
        service: service,
        room: room
      }).then(() => {
        this.successClose()
      }).catch(err => {
        console.error(err)
        this.successClose()
      })
    },
    createNewLockedRoomEntry: function () {
      this.popupValid = false
      // Check entrys
      if (this.getEntrysIsValid) {
        // is valid
        let days = arrayOfTimestamp(this.datesLocked[0], this.datesLocked[1])
        this.loading = true
        // for all services
        if (this.serviceLocked.find(el => el === 'Tous les services')) {
          this.getAllServicesIdsAndName.forEach(service => {
            if (this.roomLocked.find(el => el === 'toutes-les-salles')) {
              Object.keys(this.getRoomsDatas).forEach(room => {
                if (this.serviceState === 'fermer') {
                  // create entry
                  this.createLockRooms(days, service, room)
                } else {
                  this.deleteLockRooms(days, service, room)
                }
              })
            } else {
              this.roomLocked.forEach(roomid => {
                if (this.serviceState === 'fermer') {
                  // create entry
                  this.createLockRooms(days, service, roomid)
                } else {
                  this.deleteLockRooms(days, service, roomid)
                }
              })
            }
          })
        } else {
          // create entry for selected service
          this.serviceLocked.forEach(service => {
            if (this.roomLocked.find(el => el === 'toutes-les-salles')) {
              Object.keys(this.getRoomsDatas).forEach(room => {
                if (this.serviceState === 'fermer') {
                  // create entry
                  this.createLockRooms(days, service, room)
                } else {
                  this.deleteLockRooms(days, service, room)
                }
              })
            } else {
              this.roomLocked.forEach(roomid => {
                if (this.serviceState === 'fermer') {
                  // create entry
                  this.createLockRooms(days, service, roomid)
                } else {
                  this.deleteLockRooms(days, service, roomid)
                }
              })
            }
          })
        }
      } else {
        // if not valid -> show popup notif error or something like this
        this.setDialogError(true)
      }
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/mixins";

.popup-delete {
  text-align: center;
}

.cash-header {
  position: relative;
  text-align: center;

  .nav-toggle {
    position: absolute;
    right: 0;
    top: -20px;
  }
}

.cash-list {
  button {
    height: 48px;
  }

  .el-col {
    margin-bottom: 20px;

    @include mixins.mobile-landscape {
      margin-bottom: 10px;
    }

    @include mixins.mobile-portrait {
      margin-bottom: 10px;
    }
  }

  .el-range {
    &-editor {
      @include mixins.mobile-portrait {
        height: 100% !important;
        width: 100% !important;
        display: block;
        text-align: center;
      }
    }

    &__icon {
      @include mixins.mobile-portrait {
        display: block;
        width: 100%;
      }
    }

    &-input {
      width: 49%;

      @include mixins.mobile-portrait {
        display: block;
        height: 35px;
        width: 100%;
      }
    }

    &-separator {
      @include mixins.mobile-portrait {
        display: block;
        width: 90%;
      }
    }

    &__close-icon {
      @include mixins.mobile-portrait {
        top: 0;
        right: 10px;
        height: 35px;
        position: absolute;
      }
    }
  }
}

.el-input__inner {
  text-align: center;
  width: 100%;
}
</style>
